import {
    AddNodeBranchDTO,
    AddNodeDTO,
    CountInNode,
    HistoryEvent,
    OrganizationNode,
    OrganizationNodeDTO,
    OrganizationNodeImageSocket,
    OrganizationNodeSocket,
    OrganizationSettings,
    createOrganizationDTO,
} from '.';
import {
    IAddNodeBranchFailure,
    IAddNodeBranchRequest,
    IAddNodeBranchSuccess,
    IAddNodeFailure,
    IAddNodeRequest,
    IAddNodeSuccess,
    IDeleteNodeFailure,
    IDeleteNodeRequest,
    IDeleteNodeSuccess,
    IEditNodeFailure,
    IEditNodeRequest,
    IEditNodeSuccess,
    IGetAddNodeBranchBySocket,
    IGetAllNodesInfoFailure,
    IGetAllNodesInfoRequest,
    IGetAllNodesInfoSuccess,
    IGetOrganizationGHistoryFailure,
    IGetOrganizationHistoryRequest,
    IGetOrganizationHistorySuccess,
    IOrganizatioGetInfoRequest,
    IOrganizationGetDetailsFailure,
    IOrganizationGetDetailsRequest,
    IOrganizationGetDetailsSuccess,
    IOrganizationGetInfoFailure,
    IOrganizationGetInfoSuccess,
    IOrganizationPageActive,
    ISetOrganizationIdFromToken,
    ISetSettingsOrganization,
    IUpdateCountOfDevicesBySocket,
    IUpdateCountOfResidentsBySocket,
    IUpdateOrganizationBySocket,
    IUpdateOrganizationImageBySocket,
    IUpdateOrganizationNodeBySocket,
    IUpdateOrganizationNodeImageBySocket,
    ORGANIZATION,
    OrganizationActionType,
} from './types';

export function getNodeDetails(nodeId: number): IOrganizationGetDetailsRequest {
    return { type: ORGANIZATION.GET_DETAILS_REQUEST, payload: { nodeId } };
}

export function getNodeDetailsSuccess(data: any, nodeId: number): IOrganizationGetDetailsSuccess {
    return { type: ORGANIZATION.GET_DETAILS_SUCCESS, payload: { data, nodeId } };
}

export function getNodeDetailsFailure(value: any): IOrganizationGetDetailsFailure {
    return { type: ORGANIZATION.GET_DETAILS_FAILURE, payload: value };
}

export function getOrganizationInfo(blocking = true): IOrganizatioGetInfoRequest {
    return { type: ORGANIZATION.GET_ORGANIZATION_REQUEST, payload: { blocking } };
}

export function getOrganizationInfoSuccess(value: OrganizationNodeDTO): IOrganizationGetInfoSuccess {
    return { type: ORGANIZATION.GET_ORGANIZATION_SUCCESS, payload: value };
}

export function getOrganizationInfoFailure(value: any): IOrganizationGetInfoFailure {
    return { type: ORGANIZATION.GET_ORGANIZATION_FAILURE, payload: value };
}

export function deleteNode(nodeId: number): IDeleteNodeRequest {
    return { type: ORGANIZATION.DELETE_NODE_REQUEST, payload: { nodeId } };
}

export function deleteNodeSussess(value: any): IDeleteNodeSuccess {
    return { type: ORGANIZATION.DELETE_NODE_SUCCESS, payload: { value } };
}

export function deleteNodeFailure(value: any): IDeleteNodeFailure {
    return { type: ORGANIZATION.DELETE_NODE_FAILURE, payload: { value } };
}

export function addNode(node: AddNodeDTO): IAddNodeRequest {
    return { type: ORGANIZATION.ADD_NODE_REQUEST, payload: { node } };
}

export function addNodeSussess(id: number, data: AddNodeDTO): IAddNodeSuccess {
    return { type: ORGANIZATION.ADD_NODE_SUCCESS, payload: { id, data } };
}

export function addNodeFailure(value: any): IAddNodeFailure {
    return { type: ORGANIZATION.ADD_NODE_FAILURE, payload: { value } };
}

export function editNode(nodeId: number, node: OrganizationNode): IEditNodeRequest {
    return { type: ORGANIZATION.EDIT_NODE_REQUEST, payload: { nodeId, node } };
}

export function editNodeSuccess(value: any): IEditNodeSuccess {
    return { type: ORGANIZATION.EDIT_NODE_SUCCESS, payload: value };
}

export function editRootNodeSuccess(value: any): IEditNodeSuccess {
    return { type: ORGANIZATION.EDIT_NODE_SUCCESS, payload: value };
}

export function editNodeFailure(value: any): IEditNodeFailure {
    return { type: ORGANIZATION.EDIT_NODE_FAILURE, payload: value };
}

export function createOrganization(value: createOrganizationDTO): OrganizationActionType {
    return { type: ORGANIZATION.CREATE_ORGANIZATION, payload: value };
}
export function createOrganizationSuccess(value: any): OrganizationActionType {
    return { type: ORGANIZATION.CREATE_ORGANIZATION_SUCCESS, payload: value };
}
export function createOrganizationFailure(value: any): OrganizationActionType {
    return { type: ORGANIZATION.CREATE_ORGANIZATION_FAILURE, payload: value };
}

export function getOrganizationHistory(period?: string): IGetOrganizationHistoryRequest {
    return { type: ORGANIZATION.HISTORY_REQUEST, payload: period || 'P3Y6M4DT12H30M5S' };
}

export function getOrganizationHistorySuccess(data: HistoryEvent[]): IGetOrganizationHistorySuccess {
    return { type: ORGANIZATION.HISTORY_SUCCESS, payload: data };
}

export function getOrganizationHistoryFailure(value: any): IGetOrganizationGHistoryFailure {
    return { type: ORGANIZATION.HISTORY_FAILURE, payload: value };
}

export function updateOrganizationNodeBySocket(value: OrganizationNodeSocket): IUpdateOrganizationNodeBySocket {
    return { type: ORGANIZATION.UPDATE_ORGANIZATION_NODE_BY_SOKET, payload: value };
}

export function updateOrganizationBySocket(value: OrganizationNodeSocket): IUpdateOrganizationBySocket {
    return { type: ORGANIZATION.UPDATE_ORGANIZATION_BY_SOKET, payload: value };
}

export function updateNodeImageBySocket(value: OrganizationNodeImageSocket): IUpdateOrganizationNodeImageBySocket {
    return { type: ORGANIZATION.UPDATE_NODE_IMAGE, payload: value };
}
export function updateOrganizationImageBySocket(value: OrganizationNodeImageSocket): IUpdateOrganizationImageBySocket {
    return { type: ORGANIZATION.UPDATE_ORGANIZATION_IMAGE, payload: value };
}

export function setOrganizationSettings(value: OrganizationSettings): ISetSettingsOrganization {
    return { type: ORGANIZATION.SET_SETTINGS, payload: value };
}

export function organizationPageActive(value: boolean): IOrganizationPageActive {
    return { type: ORGANIZATION.PAGE_ACTIVE, payload: value };
}

export function updateCountOfResidentsBySoket(value: CountInNode): IUpdateCountOfResidentsBySocket {
    return { type: ORGANIZATION.UPDATE_COUNT_OF_RESIDENTS_BY_SOKET, payload: value };
}
export function updateCountOfDevicesBySoket(value: CountInNode): IUpdateCountOfDevicesBySocket {
    return { type: ORGANIZATION.UPDATE_COUNT_OF_DEVICES_BY_SOKET, payload: value };
}

export function getAllNodesInfo(rootId: number): IGetAllNodesInfoRequest {
    return { type: ORGANIZATION.GET_ALL_NODES_INFO_REQUEST, payload: rootId };
}

export function getAllNodesInfoSuccess(data: any): IGetAllNodesInfoSuccess {
    return { type: ORGANIZATION.GET_ALL_NODES_INFO_SUCCESS, payload: data };
}

export function getAllNodesInfoFailure(value: any): IGetAllNodesInfoFailure {
    return { type: ORGANIZATION.GET_ALL_NODES_INFO_FAILURE, payload: value };
}

export function addNodeBranch(data: AddNodeBranchDTO): IAddNodeBranchRequest {
    return { type: ORGANIZATION.ADD_NODE_BRANCH_REQUEST, payload: data };
}

export function addNodeBranchSuccess(id: number, data: AddNodeDTO): IAddNodeBranchSuccess {
    return { type: ORGANIZATION.ADD_NODE_BRANCH_SUCCESS, payload: { id, data } };
}

export function addNodeBranchFailure(value: any): IAddNodeBranchFailure {
    return { type: ORGANIZATION.ADD_NODE_BRANCH_FAILURE, payload: value };
}

export function receiveAddNodeBranchBySockets(value: any): IGetAddNodeBranchBySocket {
    return { type: ORGANIZATION.RECEIVE_NODE_BRANCH_ADDED_BY_SOCKET, payload: value };
}

export function setOrganizationIdFromToken(value: number): ISetOrganizationIdFromToken {
    return { type: ORGANIZATION.SET_ORGANIZATION_ID_FROM_TOKEN, payload: value };
}
